import { render, staticRenderFns } from "./ConfigSupplierList.vue?vue&type=template&id=e7f0e79c&scoped=true"
import script from "./ConfigSupplierList.vue?vue&type=script&lang=js"
export * from "./ConfigSupplierList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f0e79c",
  null
  
)

export default component.exports